import { useEffect, useId, useRef, useState } from 'react';

/**
 * Header “+” menu for creating a demand or debtor record.
 */
export default function HeaderCreateMenu({
  onNewDemand,
  onNewDebtor,
  demandDisabled = false,
  demandDisabledReason = '',
}) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const menuId = useId();

  useEffect(() => {
    function onDocClick(e) {
      if (!rootRef.current?.contains(e.target)) setOpen(false);
    }
    function onKey(e) {
      if (e.key === 'Escape') setOpen(false);
    }
    document.addEventListener('mousedown', onDocClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDocClick);
      document.removeEventListener('keydown', onKey);
    };
  }, []);

  function run(action) {
    setOpen(false);
    action?.();
  }

  return (
    <div className={`header-create${open ? ' is-open' : ''}`} ref={rootRef}>
      <button
        type="button"
        className="header-create-toggle"
        aria-label="Create record"
        aria-expanded={open}
        aria-haspopup="menu"
        aria-controls={menuId}
        onClick={() => setOpen((v) => !v)}
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M12 5v14M5 12h14"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </button>

      {open ? (
        <div className="header-create-menu" id={menuId} role="menu" aria-label="Create">
          <p className="header-create-label">Create</p>
          <button
            type="button"
            className="header-create-item"
            role="menuitem"
            disabled={demandDisabled}
            title={demandDisabled ? demandDisabledReason : undefined}
            onClick={() => run(onNewDemand)}
          >
            <span className="header-create-item-title">New demand</span>
            <span className="header-create-item-desc">Start a demand record</span>
          </button>
          <button
            type="button"
            className="header-create-item"
            role="menuitem"
            onClick={() => run(onNewDebtor)}
          >
            <span className="header-create-item-title">New debtor</span>
            <span className="header-create-item-desc">Add a debtor contact record</span>
          </button>
        </div>
      ) : null}
    </div>
  );
}
